/**
 * Who may use the claims dashboard, and who may edit in it. Claims adjudicators and finance
 * edit everything an admin edits in claims; FairFare-only pages (Process payments, VOB,
 * Manual ingest, Demo) stay super-user only. Agents work in steerage, not here.
 */
export const CLAIMS_EDIT_ROLES = ['admin', 'claims_adjudicator', 'finance'];
export const CLAIMS_READ_ROLES = [...CLAIMS_EDIT_ROLES, 'data_reader'];

export const canEditClaims = (role?: string | null): boolean =>
  role === 'super_user' || CLAIMS_EDIT_ROLES.includes(role || '');

export const canReadClaims = (role?: string | null): boolean =>
  role === 'super_user' || CLAIMS_READ_ROLES.includes(role || '');
